export default {
  "wt-button": "_wt-button_snls9p_1",
  "wt-button_busy": "_wt-button_busy_snls9p_60",
  "wt-button_theme_light": "_wt-button_theme_light_snls9p_74",
  "wt-button_disabled": "_wt-button_disabled_snls9p_75",
  "wt-button_theme_dark": "_wt-button_theme_dark_snls9p_76",
  "wt-button_align-icon_right": "_wt-button_align-icon_right_snls9p_85",
  "wt-button_size_m": "_wt-button_size_m_snls9p_92",
  "wt-button_narrow": "_wt-button_narrow_snls9p_99",
  "wt-button_size_s": "_wt-button_size_s_snls9p_104",
  "wt-button_size_xs": "_wt-button_size_xs_snls9p_116",
  "wt-button_without-text": "_wt-button_without-text_snls9p_134",
  "wt-button_with-icon": "_wt-button_with-icon_snls9p_161",
  "wt-button_flat_right": "_wt-button_flat_right_snls9p_173",
  "wt-button_flat_left": "_wt-button_flat_left_snls9p_178",
  "wt-button_mode_primary": "_wt-button_mode_primary_snls9p_183",
  "wt-button__busy-icon": "_wt-button__busy-icon_snls9p_190",
  "wt-button_mode_black": "_wt-button_mode_black_snls9p_276",
  "wt-button_mode_contrast": "_wt-button_mode_contrast_snls9p_277",
  "wt-button_highlighted": "_wt-button_highlighted_snls9p_327",
  "wt-button_mode_transparent": "_wt-button_mode_transparent_snls9p_391",
  "wt-button_mode_outline": "_wt-button_mode_outline_snls9p_436",
  "wt-button_mode_nude": "_wt-button_mode_nude_snls9p_596",
  "wt-button__icon": "_wt-button__icon_snls9p_687"
};